export default function detectDevice () {
  if (navigator.platform === 'MacIntel' || navigator.platform === 'iPhone') {
    document.body.classList.add('apple-device');
  }
}
